<div class="copo-container">
	<div class="copo-section">
		<div class="copo-section-header title-block">
			<span translate>eorder.create.order.title</span>
		</div>
	</div>
	<div class="copo-section-body copo-grid">
		<div class="copo-grid-row">
			<div class="copo-grid-row-column">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.header.customer-order-number</div>
					<div class="card-content-value">
						{{ form.getFormCustomerOrderNumber().value }}
					</div>
				</div>
			</div>
			<div class="copo-grid-row-column">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.order.soldto.name</div>
					<div class="card-content-value">
						{{ soldto ? soldto : UNDERSCORE }} </div>
				</div>
			</div>
			<div class="copo-grid-row-column" *ngIf="currencyList && currencyList.length > 0">
				<div class="card-content-info">
					<div class="card-content-label" translate>eorder.wizard.summary.header.currency.po</div>
					<div class="card-content-value">
						{{ form.getFormCurrency().value ? getCurrencyDisplay(form.getFormCurrency().value) : UNDERSCORE }}
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="cart-title">
	<div class="cart-title-heading"> <span translate>eorder.wizard.product.modification.title.cart</span> </div>
	<ng-container *ngIf="productsList && productsList.length > 0; else noItem;">
		<div class="cart-title-content"> {{productsList.length}} <span translate>eorder.wizard.product.modification.title.items</span> </div>
	</ng-container>
	<ng-template #noItem>
		<div class="cart-title-content"><span translate>woe.noitems</span></div>
	</ng-template>
	<div class="cart-product-family">
		<span class="pf-sub-category">{{productFamily?.subCategoryDescription}}</span>
		<span class="pf-form">&nbsp;({{productFamily?.formDescription  | titlecase}})</span>
	</div>
</div>
<div class="grid-column-one-full card-block">
	<div class="card-product-block" *ngFor="let product of productsList;let i=index">
		<div class="card-header copo-dark-theme" 
		[ngClass]="[getExpandPanelStatus(i) ? 'card-header-top-rounded':'card-header-rounded']">
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.itemnumber</div>
				<div class="field-value"><span>{{ i + 1 | number: '3.' }}</span></div>
			</div>

			<!-- steelgrade -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.steelgrade</div>
				<div class="field-value"><span>{{getVariabletranslation(i, 'steelGrade', product.steelGrade)}}</span></div>
			</div>

			<!-- Thickness -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.thickness</div>
				<div class="field-value"><span>{{product.thicknessValue ? product.thicknessValue : ''}}</span></div>
			</div>

			<!-- Width -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.width</div>
				<div class="field-value"><span>{{product.widthValue ? product.widthValue : ''}}</span></div>
			</div>
			
			<!-- Length -->
			<div *ngIf="isSheet" class="card-header-label">
				<div class="header-label" translate>batch.length</div>
				<div class="field-value"><span>{{product.lengthValue ? product.lengthValue : ''}}</span></div>
			</div>

			<!-- Quantity -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.quantity</div>
				<div class="field-value"><span>{{product.quantity ? product.quantity : ''}}</span></div>
			</div>

			<!-- RDD type -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.rdd.type</div>
				<div *ngIf="product.rddType === 'W'" class="field-value"><span>{{rddTypeWeek}}</span></div>
				<div *ngIf="product.rddType === 'D'" class="field-value"><span>{{rddTypeDay}}</span></div>
			</div>

			<!-- RDD Date -->
			<div class="card-header-label">
				<div class="header-label" translate>eorder.wizard.product.rdd</div>
				<div *ngIf="product.rddType === 'W'" class="field-value"><span>{{product.rdd ? getRddForWeek(product.rdd) : ''}}</span></div>
				<div *ngIf="product.rddType === 'D'" class="field-value"><span>{{product.rdd ? (product.rdd | copoDate:'date') : ''}}</span></div>
			</div>
			
			<div class="card-header-right card-action-block">
				<button type="button" mat-icon-button class="card-container-column card-column-eye"><mat-icon class="copo-eye-closed copo-eye-icon-open" svgIcon="open_eye"></mat-icon></button>
				<div>
					<button type="button" mat-icon-button>
						<mat-icon [ngClass]="(getExpandPanelStatus(i))?'':'drop-down-rotate'"
							svgIcon="copo_dropdown" (click)="expandPanel(i)"></mat-icon>
					</button>
				</div>
			</div>
		</div>
		<mat-expansion-panel [expanded]="isExpanded[i]">
			<ng-template matExpansionPanelContent>
				<!-- 2nd row -->
				<div class="card-content-row-2">
					<!-- Transport Mode -->
					<div class="expansion-panel-content">
						<div class="label" translate>transport.mode</div>
						<div class="content">{{getTmodeValue(product.transportMode)}}</div>
					</div>

					<!-- ShipTo -->
					<div class="expansion-panel-content">
						<div class="label" translate>eoffer.wizard.delivery.address</div>
						<div class="content">{{getSelectedShipTo(product.shipToParty)}}</div>
					</div>

					<!-- Service Level -->
					<div *ngIf="serviceLevels && serviceLevels.length > 0" class="expansion-panel-content">
						<div class="label" translate>global.servicelevel</div>
						<div class="content">{{getServiceLevelValue(product.serviceLevel)}}</div>
					</div>

					<!-- XCarb -->
					<div *ngIf="xcarbParamList && xcarbParamList.length > 0" class="expansion-panel-content">
						<div class="label" translate>xcarb.label</div>
						<div class="content">{{getXCarbValue(product.xcarb)}}</div>
					</div>

					<!-- BusinessTypes -->
					<div *ngIf="businessTypes && businessTypes.length > 0" class="expansion-panel-content">
						<div class="label" translate>global.business-type</div>
						<div class="content">{{getBusinessTypeValue(product.businessType)}}</div>
					</div>
				</div>
				<div class="card-content-variables">
					<!-- other variable fields -->
					<ng-container *ngIf="getVariablesForThirdRow(i).length > 0" formGroupName="variableFormGroup">
						<div class="variable-form-group" *ngFor="let field of getVariablesForThirdRow(i)" [ngClass]="field.hidden ?'hidden-field':''">
							<ng-container *ngIf="field.type === 'array' else nonArrayField">
								<div class="multi-input-group">
									<div class="expansion-panel-content" *ngFor="let product of getVariableFormArray(i, field.parentVariableName); let j=index; let last=last;">
										<div class="label">{{getFieldLabel(field.keys)}}</div>
										<div class="content">{{getVariableFieldDescriptionMultiItems(field.keys, i, j, field.parentVariableName, field.values, field.freeType)}}</div>
									</div>
								</div>
							</ng-container>
							<ng-template  #nonArrayField>
								<div class="expansion-panel-content">
									<div class="label">{{getFieldLabel(field.keys)}}</div>
									<div class="content">{{getVariableFieldDescription(i, field.keys, field.freeType, field.values)}}</div>
								</div>
							</ng-template>
						</div>
					</ng-container>
				</div>
				<!-- optional tolerance fields -->
				<ng-container *ngIf="getOptionalToleranceFields(i).size > 0">
					<div class="tolerance-block" *ngFor="let group of getOptionalToleranceFields(i) | keyvalue">
						<div class="tolerance-group">
							<div class="tolerance-standard">
								<div class="expansion-panel-content">
									<div class="label">{{getFieldLabel(group.value[0].keys)}}</div>
									<div class="content">{{getVariableFieldDescription(i, group.value[0].keys, group.value[0].freeType, group.value[0].values)}}</div>
								</div>
							</div>
							<div class="bold-label">
								<span translate>global.or</span>
							</div>
							<div class="tolerance-inner-group">
								<div class="expansion-panel-content">
									<div class="label">{{getFieldLabel(group.value[1].keys)}}</div>
									<div class="content">{{getVariableFieldDescription(i, group.value[1].keys, group.value[1].freeType, group.value[0].values)}}</div>
								</div>
								<div class="expansion-panel-content">
									<div class="label">{{getFieldLabel(group.value[2].keys)}}</div>
									<div class="content">{{getVariableFieldDescription(i, group.value[2].keys, group.value[1].freeType, group.value[0].values)}}</div>
								</div>
							</div>
						</div>
					</div>
				</ng-container>
			</ng-template>
		</mat-expansion-panel>
	</div>
</div>
